/* ==========================================================================
   OUTLYRS CLUB — promo-popup.js
   Shows the first-order discount card once per visitor, after a delay.
   Non-blocking: it never traps focus or dims the page, so browsing is
   uninterrupted. Dismissed via × or Escape, and never re-shown afterwards.
   ========================================================================== */
(function () {
  "use strict";

  var el = document.querySelector("[data-promo]");
  if (!el) return;

  var storageKey = el.getAttribute("data-key") || "oc_promo_seen";
  var delay = (parseFloat(el.getAttribute("data-delay")) || 5) * 1000;
  var timer = null;

  function seen() {
    try { return localStorage.getItem(storageKey) === "1"; } catch (e) { return false; }
  }
  function markSeen() {
    try { localStorage.setItem(storageKey, "1"); } catch (e) {}
  }

  function open() {
    el.classList.add("is-open");
    el.setAttribute("aria-hidden", "false");
    document.addEventListener("keydown", onKey);
  }

  function close() {
    if (timer) { clearTimeout(timer); timer = null; }
    el.classList.remove("is-open");
    el.setAttribute("aria-hidden", "true");
    document.removeEventListener("keydown", onKey);
    markSeen();
  }

  function onKey(e) { if (e.key === "Escape") close(); }

  el.addEventListener("click", function (e) {
    if (e.target.closest("[data-promo-close]")) { close(); return; }

    var copyBtn = e.target.closest("[data-promo-copy]");
    if (copyBtn) {
      var code = copyBtn.getAttribute("data-code") || "";
      var hint = el.querySelector("[data-promo-copy-hint]");
      var done = function () {
        if (hint) {
          hint.textContent = "Copied";
          setTimeout(function () { hint.textContent = "Copy code"; }, 2000);
        }
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(function () {});
      } else {
        // Fallback for browsers without the async clipboard API
        try {
          var t = document.createElement("textarea");
          t.value = code; t.setAttribute("readonly", "");
          t.style.position = "absolute"; t.style.left = "-9999px";
          document.body.appendChild(t); t.select();
          document.execCommand("copy"); t.remove(); done();
        } catch (err) {}
      }
    }
  });

  // Following the CTA counts as acted-on — don't show it again.
  var cta = el.querySelector(".promo__cta");
  if (cta) cta.addEventListener("click", markSeen);

  if (!seen()) timer = setTimeout(open, delay);
})();
